var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitterFilledWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.56 81.39"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.78 10.31a40.35 40.35 0 01-11.54 3.17 20.22 20.22 0 008.84-11.12A40.52 40.52 0 0183.3 7.24 20.11 20.11 0 0048.52 21a20.35 20.35 0 00.48 4.57c-16.7-.84-31.52-9.32-41.43-21.48a21.76 21.76 0 00-2.68 10.58 20.08 20.08 0 008.94 16.73 20.66 20.66 0 01-9.1-3v.73a20.12 20.12 0 0016.12 19.71 20.06 20.06 0 01-5.3.71 19.37 19.37 0 01-3.78-.86c2.56 8 10 14.29 18.77 14.45a40.35 40.35 0 01-25 8.59 42.24 42.24 0 01-4.8-.6A57 57 0 0031.6 80.5c37 0 57.19-30.63 57.19-57.2l-.06-2.6a40.2 40.2 0 0010.05-10.39z",
    fill: "#fff"
  })));
}

export default __webpack_public_path__ + "static/media/twitter_filled_white.c82904100f280e7ed98ff60641cfbe1e.svg";
export { SvgTwitterFilledWhite as ReactComponent };